<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'AppDemographicAge',
  props: {
    value: {
      type: String,
      validator(v) {
        return ['01', '02', '03', '04', '05', '06'].includes(v)
      },
    },
  },
  computed: {
    text() {
      switch (this.value) {
        case '01':
          return '13 - 17歳'
        case '02':
          return '18 - 24歳'
        case '03':
          return '25 - 34歳'
        case '04':
          return '35 - 44歳'
        case '05':
          return '45 - 54歳'
        case '06':
          return '55歳以上'
        default:
          return ''
      }
    },
  },
}
</script>

<style></style>
